import { Component, OnInit } from '@angular/core';
import { MdDialogRef } from '@angular/material';
import { FinanceService } from '../../../finance/finance.service';
import { SnackBarService } from '../../../services/snackbar.service';

@Component({
  selector: 'app-duplicate-document-warning',
  templateUrl: './duplicate-document-warning.component.html',
  styleUrls: ['./duplicate-document-warning.component.css']
})
export class DuplicateDocumentWarningComponent implements OnInit {
  duplicateInfo: any;
  bankAccount: any;
  tenantId: number;

  constructor(
    private dialogRef: MdDialogRef<any>,
    private financeService: FinanceService,
    private snackBarService: SnackBarService
  ) {
    if (this.dialogRef.componentInstance) {
      this.duplicateInfo = this.dialogRef.componentInstance.duplicateInfo;
      this.bankAccount = this.dialogRef.componentInstance.bankAccount;
      this.tenantId = this.dialogRef.componentInstance.tenantId;
    }
  }

  ngOnInit() {
  }

  cancel(): void {
    this.dialogRef.close({ action: 'cancel' });
  }

  continueAnyway(): void {
    this.dialogRef.close({ action: 'continue', duplicateId: this.duplicateInfo.duplicateId });
  }

  downloadExisting(): void {
    if (!this.duplicateInfo.duplicateUniqueName || !this.bankAccount || !this.tenantId) {
      this.snackBarService.showSimpleMsj('Missing information to download document');
      return;
    }
    
    this.financeService.downloadBankStatement(
      this.duplicateInfo.duplicateUniqueName,
      this.bankAccount.accountId,
      this.tenantId,
      this.duplicateInfo.duplicateDocumentName
    ).subscribe(
      (blob: Blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = this.duplicateInfo.duplicateDocumentName || this.duplicateInfo.duplicateUniqueName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        this.snackBarService.showSimpleMsj('Document downloaded successfully');
      },
      error => {
        this.snackBarService.showSimpleMsj('Error downloading document: ' + (error.message || 'Unknown error'));
      }
    );
  }

  previewExisting(): void {
    // Open preview dialog (would need to inject MdDialog and open BankStatementPreviewComponent)
    // For now, just download
    this.downloadExisting();
  }
}




// WEBPACK FOOTER //
// ./src/app/entities/finance/duplicate-document-warning/duplicate-document-warning.component.ts